export var subscriptionDescriptions = [
    'Идеально для ознакомления и небольших проектов',
    'Оптимальный выбор для регулярного использования',
    'Максимальные возможности для крупных компаний',
];
export var monthPrices = ['бесплатно', '350$/месяц', '550$/месяц'];
export var yearPrices = ['бесплатно', '300$/месяц', '450$/месяц'];
export var points = [
    [
        '1 отчет в месяц',
        '1 конструкция в отчете',
        'Работа с одним этажом',
        'Новости партнеров',
        'Ограниченая база материалов',
        'Ограниченые узлы примыкания',
    ],
    [
        '20 отчетов в месяц',
        'До 20 конструкций',
        'Работа с 4 этажами',
        'База данных материалов',
        'Расчёт: звукоизоляции, теплотехнических, противопожарных характеристика',
        'Типовые узлы примыкания',
        'Создание конструкций, выполнение расчетов',
        'Подпись отчета',
        'Проверка отчета',
        'Полный отчет',
    ],
    [
        'Подпись отчета',
        'До 50 конструкций',
        'Работа с 10 этажами',
        'База данных материалов',
        'Расчёт: звукоизоляции, теплотехнических, противопожарных характеристика',
        'Специальные сгенерированные узлы примыкания',
        'Создание конструкций, выполнение расчетов',
        'Приоритетная поддержка',
        'Подпись отчета',
        'Проверка отчета',
        'Интеграция AutoCAD, Revit',
    ],
];
export var titles = ['Trial', 'Standart', 'Pro'];
export var crossedPoints = [['Проверка отчета', 'Подпись отчета'], [], []];
